<template>
  <div class="member-consent-checkboxes">
    <div class="wd-mb-2">
      <v-checkbox
        :model-value="modelValue.isTermsAccepted"
        hide-details
        color="orange50"
        @update:model-value="updateConsent('isTermsAccepted', $event)"
      >
        <template #label>
          <span v-html="$t('create_account_term_of_use')"> </span>
        </template>
      </v-checkbox>
    </div>

    <div class="wd-mb-3">
      <v-checkbox
        :model-value="modelValue.isMarketingAllowed"
        hide-details
        color="orange50"
        @update:model-value="updateConsent('isMarketingAllowed', $event)"
      >
        <template #label>
          <span class="text-sm">{{ $t('create_account_marketing_agreement') }}</span>
        </template>
      </v-checkbox>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: {
    isTermsAccepted: boolean
    isMarketingAllowed: boolean
  }
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: { isTermsAccepted: boolean; isMarketingAllowed: boolean }): void
}>()

function updateConsent(key: 'isTermsAccepted' | 'isMarketingAllowed', value: boolean | null) {
  emit('update:modelValue', {
    ...props.modelValue,
    [key]: !!value,
  })
}
</script>
